import React from 'react';

interface TestClassComponentProps {
    user:string;
}
export class TestClassComponent extends React.Component<TestClassComponentProps> {
    
    constructor(props: TestClassComponentProps){
        super(props);
        /*只会调用一次，如果比较有强状态,初始化比较重的组件比较适合用class组件，
        否则用FC组件可以避免取值变化，需要bind this等情况 */
        console.log('TestClassComponent constructor');
    }

    
    /*扩展类方式实现的组件，由于每次执行的时候拿到的this的值，可能不尽相同*/
    showMessage = ()=>{
        alert(`fllow: ${this.props.user}`);
    }
    handleClick = ()=>{
        setTimeout(this.showMessage,5000);
    }
    render (){
        return <button onClick={this.handleClick}>fllow</button>
    };
}